<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa fa-map-signs" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToAffiliateConsole" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">{{cvbtnMangeAffCodes}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="showCreateSession(false)" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-3">
                <!-- Frontend Search -->
                <!-- <b-form-input
                  id="search"
                  v-model="filter"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>Frontend Search -->

                  <!--Backend Search  -->
                  <input class="form-control"
                  v-model="whereFilter.search_param"
                  type="search"
                  @input="searchFromBackend"
                  :placeholder="cvSearchText" /><!--Backend Search  -->
              </b-col>
              <!-- Counselor Name Filter -->
              <b-col class="mb-2 col-12 col-sm-4" v-if="userData.user_role == 'USERROLE11111'">
                <select v-model="whereFilter.user_id" class="form-control" @change="setCounsellor" v-if="counsellorObjList.length > 0" title="Counselor List">
                  <option :value="null" disabled>Counselor List</option>
                  <option value="null">All</option>
                  <option v-for="(counsellor, index) of counsellorObjList" :key="(index+1)" :value="counsellor.user_id">
                    {{counsellor.user_name ? counsellor.user_name : "--- "+counsellor.user_email}}&nbsp;({{getUserRole(counsellor.user_role)}})
                  </option>
                </select>
              </b-col><!-- Counselor Name Filter -->

              <!-- Session State Filter -->
              <b-col class="mb-2 col-12 col-sm-4" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
                <select v-model="whereFilter.session_state" class="form-control" @change="setSessionState" title="session states">
                  <option :value="null" disabled>GPath Assessment States</option>
                  <option value="null">All</option>
                  <option v-for="(sessionState, index) of GPathStateObj" :key="(index+1)" :value="index">
                    {{sessionState}}
                  </option>
                </select>
              </b-col><!-- Session State Filter -->

              <!-- GPath Producat Id -->
              <b-col class="mb-2 col-12 col-sm-4" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
                <select v-model="whereFilter.pdt_id" class="form-control" @change="setProductId" title="session states">
                <!-- <option :value="null" disabled selected>GPath Assessment States</option> -->
                  <option value="null">All</option>
                  <option v-for="item in gpcPdtIdList" :key="item.id" :value="item.id">
                  {{ item.id }}
                </option>
              </select>
              </b-col><!-- GPath Producat Id -->
            </b-row>
          </b-col>
          <b-col class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
            <!-- Backend csv download -->
            <i v-if="gpath_sessionObjList && gpath_sessionObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove Filter" @click="removeAllFilter"></i>
            <!-- Backend csv download -->
          </b-col>
        </div>
        <div class="iq-card row p-3" :key="currentBatchNo">
          <b-col class="container_minheight" md="12" v-if="gpath_sessionObjList && gpath_sessionObjList.length > 0">
            <b-table
              hover
              responsive
              :items="gpath_sessionObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(user_name)="data">
                <span class="pointer" @click="openUserProfile(data.item.user_id)"><b>{{ data.item.user_name }}</b></span><br>
                <span><small>
                  Id:&nbsp;{{ data.item.user_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.user_id)"></i><br>
                  Email:&nbsp;{{ data.item.user_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.user_email)"></i><br><br>
                  Class:&nbsp;<span v-if="data.item.class_name">{{ fixedClassName(data.item.class_name) }}</span><span v-else><b-badge style="vertical-align: middle; color: #FFF; background: #e5252c !important;">Profile Incomplete</b-badge></span><br>
                  {{data.item.institute_name}}<br>
                  {{data.item.institute_city ? data.item.institute_city : '' }}
                  {{data.item.institute_state ? ', ' + data.item.institute_state : '' }}
                  {{data.item.institute_country ? ', ' + data.item.institute_country : '' }}<br>
                </small></span>
                <div v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" title="Edit Session Details" size="sm" @click="gpath_sessionEditV1(data.item)"><i class="fa fa-edit m-0"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="showGPathSessionDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="generateReport(data.item)" size="sm" title="Generate Report"><i class="fa fa-refresh" aria-hidden="true"></i></b-button>
                  <b-button v-if="userData.user_role == 'USERROLE11111'" class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="generateReport(data.item, true)" size="sm" title="Generate Report Server"><i class="ri-restart-fill"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="gpath_sendMail('MODAL', data.item)" title="Send Mail"><i class="fa fa-envelope-o"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="openInBrowser('REPORT', data.item)" title="Open Report in Browser"><i class="fa fa-chrome"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="showPaymentList(data.item)" title="User Payment Transaction"><i class="fa fa-money"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="openReport(data.item.report)" v-if="data.item.report" size="sm" title="View GPaths Report"><i class="fa fa-map-signs" aria-hidden="true"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="viewTakeNotes(data.item)" size="sm" title="Add/Edit Counselor Notes"><i class="fa-solid fa-note-sticky font-size-20" aria-hidden="true"></i></b-button>
                  <br>

                  <small>Id: {{ data.item.gps_id}}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Session Id" @click="doCopy(data.item.gps_id)"></i></small><br>
                  <small>Product Code: <b-badge :style="getColorCode(data.item.pdt_id)" class="pointer" size="md">{{ data.item.pdt_id }}</b-badge>&nbsp;&nbsp;</small><br>
                  <b-badge style="vertical-align: middle; color: #FFF; background: #3366CC !important;" class="pointer" size="md" @click="openInBrowser('CAREER', data.item)" title="Analyse Career Assessment Responses">C</b-badge>&nbsp;&nbsp;
                  <b-badge style="vertical-align: middle; color: #FFF; background: #3366CC !important;" class="pointer" @click="openInBrowser('APTITUDE', data.item)" title="Analyse Aptitude Assessment Responses">A</b-badge>&nbsp;&nbsp;
                  <b-badge style="vertical-align: middle; color: #FFF; background: #3366CC !important;" class="pointer" @click="openInBrowser('SKILL', data.item)" title="Analyse Skill Assessment Responses">S</b-badge>&nbsp;&nbsp;
                  <b-badge style="vertical-align: middle; color: #FFF; background: #3366CC !important;" class="pointer" @click="openInBrowser('EXTRACURRICULAR', data.item)" title="Analyse Extracurricular Assessment Responses">E</b-badge>&nbsp;&nbsp;
                  <b-badge style="vertical-align: middle; color: #FFF; background: #e5252c !important;" class="pointer" @click="openInBrowser('DEBUG', data.item)" title="View, Debug & Fix Duplicate Assessment">Debug</b-badge>&nbsp;&nbsp;
                </div>
                <div v-else-if="userData.user_role == 'USERROLE11116'">
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="generateReport(data.item, false)" size="sm" title="Generate Report"><i class="fa fa-refresh" aria-hidden="true"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="gpath_sendMail('MODAL', data.item)" title="Send Mail"><i class="fa fa-envelope-o"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" size="sm" @click="openInBrowser('REPORT', data.item)" title="Open Report in Browser"><i class="fa fa-chrome"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="openReport(data.item.report)" v-if="data.item.report" size="sm" title="View GPaths Report"><i class="fa fa-map-signs" aria-hidden="true"></i></b-button>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="viewTakeNotes(data.item)" size="sm" title="Add/Edit Counselor Notes"><i class="fa-solid fa-note-sticky font-size-20" aria-hidden="true"></i></b-button><br>

                  <small>Id: {{ data.item.gps_id}}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Session Id" @click="doCopy(data.item.gps_id)"></i></small><br>
                  <b-badge v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" style="vertical-align: middle; color: #FFF; background:#3366CC !important;" class="pointer" @click="openInBrowser('CAREER', data.item)" title="Analyse Career Assessment Responses">C</b-badge>&nbsp;&nbsp;
                  <b-badge v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" style="vertical-align: middle; color: #FFF; background:#3366CC !important;" class="pointer" @click="openInBrowser('APTITUDE', data.item)" title="Analyse Aptitude Assessment Responses">A</b-badge>&nbsp;&nbsp;
                  <b-badge v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" style="vertical-align: middle; color: #FFF; background:#3366CC !important;" class="pointer" @click="openInBrowser('SKILL', data.item)" title="Analyse Skill Assessment Responses">S</b-badge>&nbsp;&nbsp;
                  <b-badge v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'" style="vertical-align: middle; color: #FFF; background:#3366CC !important;" class="pointer" @click="openInBrowser('EXTRACURRICULAR', data.item)" title="Analyse Extracurricular Assessment Responses">E</b-badge>&nbsp;&nbsp;
                </div>
                <div v-else>
                  <b-button class="btn btn actionIcon font-size-20 mr-1 mb-1 btn-secondary btn-sm" @click="openReport(data.item.report)" v-if="data.item.report" size="sm" title="View GPaths Report"><i class="fa fa-map-signs" aria-hidden="true"></i></b-button>
                </div>
              </template>

              <template v-slot:cell(parent_data)="data">
                <span class="pointer" @click="openUserProfile(data.item.user_id)">{{ data.item.parent_data | is_empty}}</span><br>
              </template>

              <template v-slot:cell(product)="data">
                <div class="pointer" v-for="(pdt, index) of userSubsPdtMap[data.item.user_id].split(',')" :key="index" @click="goToUserSubscriptions(data.item.user_id)">
                  <b-badge v-if="pdt.length > 0" :style="getproductColorCode()" class="mb-2">
                    {{pdt}}
                  </b-badge><br>
                </div>
              </template>

              <template v-slot:cell(invoice_url)="data" class="cursor-pointer">
                <!-- Invoice -->
                <small v-if="(userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118')">
                  Inv:&nbsp;<span class="success-color">{{ data.item.pay_tid ? data.item.pay_tid : " - " }}</span>&nbsp;
                  <i v-if="data.item.invoice_url" class="fa fa-solid fa-credit-card m-0" @click="openInvoice(data.item.invoice_url)" title="Invoice"></i>
                  <br/>
                </small>
                <!-- Invoice -->

                <!-- Discount Code -->
                <small>
                  Code:&nbsp;
                  <span style="vertical-align: middle; color: #FFF; background: #e5252c !important;">
                    {{ data.item.aff_code ? data.item.aff_code : " - " }}
                  </span>
                </small><br/><!-- Discount Code -->

                <!-- Counselor Name -->
                <small>
                  <span v-if="data.item.counsellor_name">{{getUserRole(data.item.counselor_role)}}:&nbsp;{{ data.item.counsellor_name }}</span>&nbsp;
                  <i class="ri-exchange-line m-0 font-size-20 primary-color" title="Change Lead Counselor" @click="showChangeCounsellor(data.item)"></i>
                </small><br/><!-- Counselor Name -->

                <!-- Payment Source -->
                <small>
                  <span v-if="data.item.source">source&nbsp;{{ data.item.source }}</span><br>
                  <span v-if="data.item.sales_user_id" :title="data.item.sales_user_email">Sales Person:&nbsp;{{ data.item.sales_user_name }}</span><br>
                </small><br/><!-- Payment Source -->
              </template>

              <template v-slot:cell(session_state)="data">
                <small>
                  <b-badge :style="getStateColorCode(data.item.session_state)" class="mt-2">
                    {{ GPathStateObj[data.item.session_state] }}
                  </b-badge>
                </small>
              </template>

              <template v-slot:cell(created_on)="data">
                {{ data.item.created_on | dateFormat }}
              </template>
              <template v-slot:cell(modified_on)="data">
                {{ data.item.modified_on | dateFormat }}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            We did not find any students. <span class="primary-color pointer" @click="showCreateSession">Click here</span>&nbsp;to invite your students to take GPaths: Futuristic Career Interest Assessment
          </b-col>
          <b-col sm="12" md="12" class="my-1">
            <b-row>
              <b-col sm="12" md="7">
                <b-btn class="mb-2" variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
              </b-col>
              <b-col sm="5" md="5">
                <b-pagination
                  v-model="currentBatchNo"
                  :total-rows="totalRows"
                  :per-page="dataPerPage"
                  align="fill"
                  size="sm"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <!-- Gpaths Create Your Custom Session -->
    <b-modal
      v-model="showSessionCreationModal"
      scrollable
      :title="cvModalTitle"
      size="xxl"
      id="inviteModal"
    >
      <InviteUser :propProductCode="GideProducts.GPATHS" :propProductName="GideProducts.GPATHS" :propOpenedInModal="true" :propCounsellor="userData" @emitCloseInviteUser="emitCloseInviteUser" />
      <template #modal-footer="">
        <b-button size="sm" @click="emitCloseInviteUser()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
    <!-- Gpaths Create Your Custom Session  -->

    <!-- Allot student a different counsellor -->
    <b-modal
      v-model="showChangeCounsellorModal"
      scrollable
      :title="cvChangeCounsellorModalTitle"
      size="lg"
    >
      <ChangeStrategist :propOpenedInModal="true" :propUserObj="propGpathUser" @emitCloseChangeCounselllor="emitCloseChangeCounselllor" />
      <template #modal-footer="">
        <b-button size="sm" @click="emitCloseChangeCounselllor()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>
    <!-- Allot student a different counsellor -->

    <!-- GPathSessionEditV1 -->
    <b-modal
      v-model="showModelGPathSessionEditV1"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
      >
        <GPathSessionEditV1 :propOpenedInModal="true" :propGPathSessionObj="gpath_sessionEditObj" @emitCloseGPathSessionEditModal="closeGPathSessionEditModalV1" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeGPathSessionEditModalV1()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- GPathSessionEditV1 -->

    <!-- SendMail -->
    <b-modal
      v-model="showModelSendMail"
      scrollable
      :title="cvSendMailModalHeader"
    >
      <SendMail :propOpenedInModal="true" :propSendMailObj="sendMailObj" @emitCloseGPathSendMailModal="emitCloseGPathSendMailModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="emitCloseGPathSendMailModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- SendMail -->

    <b-modal v-model="showModelGPathSessionDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelGPathSessionDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpath_sessionDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

     <!-- Take notes -->
     <b-modal v-model="showModelTakeNotes" size="xxl" title="Add/Update Counselor Notes" ok-title="Update" cancel-title="Cancel">
      <GPathNotes :propGpathsSessionDetailsObj="gpathsSessionDetails" @emitCloseGPathNotesModal="emitCloseGPathNotesModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="emitCloseGPathNotesModal()">{{cvbtnModalCancel}}</b-button>
      </template>
    </b-modal><!-- Take notes -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { GPathSessions } from "../../../FackApi/api/GPathSession.js"
import InviteUser from "../../../components/InviteUser.vue"
import ChangeStrategist from "../SPCM/SpcmChangeStrategist.vue"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import GPathData from "../../../FackApi/json/GPath.json"
import SendMail from "../../../components/SendMail.vue"
import SendMailModules from "../../../FackApi/json/SendMailModules.json"
import { User } from "../../../FackApi/api/user"
import userPermission from "../../../Utils/user_permission.js"
import GideProducts from "../../../FackApi/json/GideProducts.json"
import GPathNotes from "./GPathNotes.vue"
import GPathSessionEditV1 from "./GPathSessionEditV1.vue"
import { GPathConfig } from "../../../FackApi/api/GpathConfig"
import Utility from "../../../Utils/utility.js"

export default {
  name: "GPathDashboard",
  components: {
    InviteUser,
    ChangeStrategist,
    SendMail,
    GPathNotes,
    GPathSessionEditV1
  },
  data () {
    return {
      apiName: "gpath_session_list",
      cvCardTitle: "GPaths Dashboard",
      cvbtnAddNew: "Invite User",
      cvbtnMangeAffCodes: "GPath Codes",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      showModelSendMail: false,
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "GPaths",
      cvSendMailModalHeader: "GPaths Send Mail",
      cvAddModalHeader: "Add GPaths",
      cvbtnModalCancel: "Close",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "GPaths Dashboard",
      csvTitle: "GPathsUserReport",
      showModelInviteUser: false,
      showModelGPathSessionEdit: false,
      showModelGPathSessionEditV1: false,
      showModelGPathSessionDelete: false,
      showModelTakeNotes: false,
      sortBy: "name",
      sortDesc: false,
      columns: [],
      gpath_sessionObjList: [],
      gpath_sessionEditObj: null,
      filter: null,
      filterOn: [],
      delObj: null,
      whereFilter: {
        user_id: "",
        session_state: 99, // Report Generated
        search_param: "",
        pdt_id: ""
      },
      counsellorObjList: [],
      showSessionCreationModal: false,
      showChangeCounsellorModal: false,
      GPathStateObj: {
        "1": "INITIATED",
        "2": "PERSONAL INFO COMPLETE",
        "3": "EDUCATION INFO COMPLETED",
        "4": "PAYMENT DONE",
        "5": "CAREER COMPLETED",
        "6": "SKILL COMPLETED",
        "7": "APTITUDE COMPLETED",
        "8": "EXTRACURRICULAR COMPLETED",
        "9": "ASSESSMENT COMPLETE [REPORT AWAITED]",
        "99": "REPORT GENERATED"
      }, // If changed here ensure changes are done in school dashboard gpaths as well
      cvModalTitle: "Invite to take GPaths Career Assessment",
      cvChangeCounsellorModalTitle: "Change Counselor",
      sendMailObj: null,
      SendMailModules: SendMailModules,
      totalRows: 1,
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: false,
      propGpathUser: {},
      GideProducts: GideProducts,
      userSubsPdtMap: {},
      gpathsSessionDetails: {},
      gpcPdtIdList: [],
      doCopy: Utility.doCopy
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }

    this.whereFilter.user_id = this.userData.user_id // On Mounted get the data for the current logged in user
  },
  async mounted () {
    // Setting views according to the user's role
    switch (this.userData.user_role) {
      case "USERROLE11111": // Gide Admin
      case "USERROLE11118": // Gide Counsellors
      case "USERROLE11116": // External counsellors(org_role)
        this.columns = [
          { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
          { label: "User Name", key: "user_name", class: "text-left align-text-top w-350px", sortable: true },
          { label: "Parent Info", key: "parent_data", class: "text-left align-text-top w-300px", sortable: true },
          { label: "Session Info", key: "session_state", class: "text-left align-text-top w-200px", sortable: true },
          { label: "Payments", key: "invoice_url", class: "text-left align-text-top w-300px", sortable: true },
          { label: "Product Subscription ", key: "product", class: "text-left align-text-top", sortable: true },
          { label: "Assessment Date", key: "modified_on", class: "text-left align-text-top w-200px", sortable: true },
          { label: "Created on", key: "created_on", class: "text-left align-text-top w-200px", sortable: true }
        ]
        break
      case "USERROLE11114":
        this.columns = [
          { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
          { label: "User Name", key: "user_name", class: "text-left align-text-top", sortable: true },
          { label: "Session Data", key: "session_state", class: "text-left align-text-top w-200px", sortable: true },
          { label: "Assessment Date", key: "modified_on", class: "text-left align-text-top", sortable: true }
        ]
    }

    if (this.$route.params.user_id) {
      this.whereFilter.search_param = this.$route.params.user_id
    }

    this.setFilters()
    socialvue.index()

    // Counsellor or admin viewing the student's GPATH sessions
    if (this.$route.query.user_id && (this.userData.user_role == "USERROLE11118" || this.userData.user_role == "USERROLE11111")) {
      // Counsellor views the gpath_sessions of a single user
      this.whereFilter = { ...this.whereFilter, student_id: this.$route.query.user_id }
    }
    else if (this.userData.user_role == "USERROLE11118") {
      // Counsellor is viewing the gpath_session list
      this.whereFilter = { ...this.whereFilter, counsellor_view: true }
    }

    this.gpath_sessionList()

    // open up the invite model if 'invite_model' query parameter is passed as true
    if (this.$route.query.invite_model) {
      this.showSessionCreationModal = true
      window.history.pushState("GPathSessionList", "Title", "/gpath_session_list")
    }

    this.gpathsproductIdListGet()
  },
  methods: {
    /**
     * openUserProfile
     */
    openUserProfile (userId) {
      let url = `/user/${userId}`
      window.open(url, "_blank")
    },
    /**
     * openReport
     */
    openReport (url) {
      window.open(url, "_blank")
    },
    /**
     * showPaymentList
     */
    showPaymentList (user) {
      window.open(`/payTransactions_list/${user.user_id}`)
    },
    /**
     * openInvoice
     */
    async openInvoice (url) {
      window.open(url, "_blank")
    },
    /**
     * emitCloseInviteUser
     */
    emitCloseInviteUser () {
      this.gpath_sessionList()
      this.showSessionCreationModal = false
    },
    /**
     * emitCloseChangeCounselllor
     */
    emitCloseChangeCounselllor () {
      this.gpath_sessionList()
      this.showChangeCounsellorModal = false
    },
    /**
     * emitCloseGPathSendMailModal
     */
    async emitCloseGPathSendMailModal () {
      this.showModelSendMail = false
    },

    /**
     * emitCloseGPathNotesModal
     */
    async emitCloseGPathNotesModal () {
      await this.gpath_sessionList()
      this.showModelTakeNotes = false
    },
    /**
      * searchFromBackend
      */
    searchFromBackend () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }

      if (this.whereFilter.search_param.length <= 3) {
        return
      }

      this.currentBatchNo = 1

      if (this.whereFilter.search_param.length > 3) {
        this.whereFilter.session_state = null
        this.whereFilter.pdt_id = null
        this.whereFilter.user_id = null
      }

      this.gpath_sessionList()
    },
    /**
     * setFilters
     */
    async setFilters () {
      if (this.userData.user_role == "USERROLE11116") {
        return
      }

      // Get users of ORG along with Admin and GIDE COunselor
      const userListSearchResp = await User.userListSearch(this, { user_role: "USERROLE11118,USERROLE11111,USERROLE11116" })
      if (userListSearchResp.resp_status) {
        this.counsellorObjList = userListSearchResp.resp_data.data
      }
    },
    /**
     * setCounsellor
    */
    async setCounsellor () {
      this.gpath_sessionList()
    },
    /**
     * showCreateSession
     */
    showCreateSession (openInNewTab = false) {
      if (openInNewTab) {
        window.open("/inviteV1?category=sales")
      }
      else {
        this.showSessionCreationModal = true
      }
    },
    /**
     * showChangeCounsellor
     */
    showChangeCounsellor (gpathUser) {
      this.propGpathUser = {
        gide_user_id: gpathUser.user_id,
        stu_name: gpathUser.user_name,
        stu_email: gpathUser.user_email,
        gps_id: gpathUser.gps_id,
        counsellor_id: gpathUser.counsellor_id,
        counsellor_name: gpathUser.counsellor_name,
        history: gpathUser.history,
        counselor_team: null
      }
      this.showChangeCounsellorModal = true
    },
    /**
     * goToAffiliateConsole
     */
    async goToAffiliateConsole () {
      if (this.userData.user_role == "USERROLE11116") {
        // Show the affiliate codes og gpaths only, when the user lands this page via GPATHS dashboard
        this.$router.push(`/affiliate_codes_dashboard?module_name=${GideProducts.GPATHS}`)
      }
      else {
        this.$router.push("/affiliate_codes_dashboard")
      }
    },
    /**
     * gpath_sendMail
     */
    async gpath_sendMail (type, gpathSessionObj) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_session_edit/" + this.gpath_sessionEditObj.gps_id)
        }
        else {
          if (gpathSessionObj.source && gpathSessionObj.source.includes("CSV")) {
            this.sendMailObj = {
              user_id: gpathSessionObj.user_id,
              user_name: gpathSessionObj.user_name,
              user_email: gpathSessionObj.user_email,
              cc_email: gpathSessionObj.parent_email,
              subject: { GPATH_REPORT: this.SendMailModules.GPATH_REPORT }
            }
          }
          else {
            this.sendMailObj = {
              user_id: gpathSessionObj.user_id,
              user_name: gpathSessionObj.user_name,
              user_email: gpathSessionObj.user_email,
              cc_email: gpathSessionObj.parent_email,
              subject: {},
              gps_id: gpathSessionObj.gps_id
            }

            for (let key in this.SendMailModules) {
              if (key.includes("GPATH")) {
                this.sendMailObj.subject[key] = this.SendMailModules[key]
              }
            }
          }

          this.showModelSendMail = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_sendMail() and Exception:", err.message)
      }
    },
    /**
     * set Set Session State
    */
    async setSessionState () {
      this.gpath_sessionList()
    },
    /**
     * set Set Product Id
    */
    setProductId () {
      this.whereFilter.session_state = null
      this.whereFilter.user_id = null
      this.gpath_sessionList()
    },
    /**
     * gpath_sessionList
     */
    async gpath_sessionList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.downloadCsv = downloadCsv

        let gpathSessionListResp = await GPathSessions.gpath_sessionList(this, this.whereFilter)
        if (gpathSessionListResp.resp_status) {
          if (downloadCsv) {
            window.open(gpathSessionListResp.resp_csv_file_url)
            return
          }

          if ((this.whereFilter.search_param || "").length >= 0 && !loadViaLoadMore) {
            this.gpath_sessionObjList = [ ...gpathSessionListResp.resp_data.data ]
          }
          else {
            this.gpath_sessionObjList = [ ...this.gpath_sessionObjList, ...gpathSessionListResp.resp_data.data ]
          }
          this.totalRows = this.gpath_sessionObjList.length
          this.showLoadMoreBtn = true
          // Adding the serial numbers:
          this.gpath_sessionObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.gpath_sessionObjList.length

          this.userSubsPdtMap = { ...this.userSubsPdtMap, ...gpathSessionListResp.user_product_map }
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.showLoadMoreBtn = false
          this.toastMsg = gpathSessionListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.gpath_sessionObjList = []
        }
      }
      catch (err) {
        console.log("Exception occurred at gpath_sessionList() and Exception:", err.message)
      }
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.gpath_sessionList(true)
    },
    /**
     * gpath_sessionAdd
     */
    gpath_sessionAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_session_add")
        }
        else {
          this.showModelInviteUser = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_sessionAdd() and Exception:", err.message)
      }
    },
    /**
     * gpath_sessionEditV1
     */
    gpath_sessionEditV1 (item) {
      this.gpath_sessionEditObj = item
      this.showModelGPathSessionEditV1 = true
    },
    /**
     * showGPathSessionDeleteDialog
     */
    showGPathSessionDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelGPathSessionDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showGPathSessionDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpath_sessionDelete
     */
    async gpath_sessionDelete () {
      try {
        let gpathSessionDelResp = await GPathSessions.gpath_sessionDelete(this, this.delObj.gps_id)
        await ApiResponse.responseMessageDisplay(this, gpathSessionDelResp)

        if (gpathSessionDelResp && !gpathSessionDelResp) {
          this.showModelGPathSessionDelete = false
          return false
        }

        let index = this.gpath_sessionObjList.indexOf(this.delObj)
        this.gpath_sessionObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelGPathSessionDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpath_sessionDelete() and Exception:", err.message)
      }
    },
    /**
     * closeInviteUserModal
     */
    closeInviteUserModal () {
      this.showModelInviteUser = false
    },
    /**
     * closeGPathSessionEditModalV1
     */
    closeGPathSessionEditModalV1 () {
      this.showModelGPathSessionEditV1 = false
    },
    /**
     * Generate the report
     */
    async generateReport (userData, useLambda = false) {
      this.showActionBtns = false

      const postData = {
        user_id: userData.user_id,
        user_email: userData.user_email,
        pdt_id: userData.pdt_id,
        gps_id: userData.gps_id,
        showHTML: "0",
        filename: "gpaths",
        email_send_flag: "1"
      }

      if (useLambda) {
        // Generate report with lambda function
        /*
        GPathSessions.gpath_session_report_generate_lambda(this, postData)
        this.toastMsg = "Your report is being generated. It can take upto 5 mins to generate your report. Please note that a copy of the report will be sent to both your registered email address and the parent's email ID shared by you for your reference"
        this.toastVariant = "primary"
        this.showToast = true
        */

        // Generate report with https://gpathserver.gide.ai
        let reportResp = await GPathSessions.gpath_session_report_generate(this, postData, useLambda)
        if (!reportResp.resp_status) {
          this.toastMsg = "Oops! Looks like you have not completed the assessment. Please re-take the assessment. In case the problem persists please reach out to us on support@gide.ai"
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      else {
        // Generate report with https://gpaths.gide.ai
        let reportResp = await GPathSessions.gpath_session_report_generate(this, postData)
        if (!reportResp.resp_status) {
          this.toastMsg = "Oops! Looks like you have not completed the assessment. Please re-take the assessment. In case the problem persists please reach out to us on support@gide.ai"
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
    },
    /**
     *  open In Browser
     *  Append the classGrade to GPathData.GPATH_CAREER, GPathData.GPATH_SKILL, GPathData.GPATH_APTITUDE, GPathData.GPATH_COUNSELLOR if class <= 8
     */
    openInBrowser (type, sessionData) {
      let productIdAlias = sessionData.pdt_id.replace("APPGPATHPRODUCTID", "")

      let url = ""
      switch (type) {
        case "DEBUG":
          url = `${process.env.VUE_APP_SERVER_URL}/appResult_list_fix/${sessionData.pdt_id}/${sessionData.user_id}`
          break
        case "REPORT":
          url = `${process.env.VUE_APP_SERVER2_URL}/gpath_report_test/${sessionData.user_id}/${sessionData.pdt_id}/${sessionData.gps_id}`
          break
        case "CAREER":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${GPathData.GPATH_CAREER}${productIdAlias}/${sessionData.user_id}/dummy_aprs_id?attempt=NA`
          break
        case "SKILL":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${GPathData.GPATH_SKILL}${productIdAlias}/${sessionData.user_id}/dummy_aprs_id?attempt=NA`
          break
        case "APTITUDE":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${GPathData.GPATH_APTITUDE}${productIdAlias}/${sessionData.user_id}/dummy_aprs_id?attempt=NA`
          break
        case "EXTRACURRICULAR":
          url = `${process.env.VUE_APP_SERVER_URL}/app_result_analyse/${GPathData.GPATH_COUNSELLOR}${productIdAlias}/${sessionData.user_id}/dummy_aprs_id?attempt=NA`
          break
        default:
      }

      window.open(url, "_blank")
    },
    /**
     * getStateColorCode
     */
    getStateColorCode (statecode) {
      return `vertical-align: middle; color: #FFF; background: ${GPathData.StateInfoColors[statecode]} !important;`
    },
    /**
     * backend Csv Download
     */
    async backendCsvDownload () {
      this.gpath_sessionList(false, true)
    },
    /**
     * goToUserSubscriptions
     */
    goToUserSubscriptions (userid) {
      window.open(`my_billing_history/${userid}`)
    },
    /**
     * getproductColorCode
     */
    getproductColorCode (registrationState = null) {
      if (registrationState && registrationState != 1) {
        return `vertical-align: middle; color: #FFF; background: #FF9900 !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: #e5252c !important;`
      }
    },
    /**
     * viewTakeNotes
     */
    viewTakeNotes (item) {
      try {
        this.gpathsSessionDetails = item
        this.showModelTakeNotes = true
      }
      catch (err) {
        console.error("Exception occurred at viewTakeNotes() and Exception:", err.message)
      }
    },
    /**
     * get User Role
     */
    getUserRole (userRole) {
      switch (userRole) {
        case "USERROLE11111":
          return "Admin"
        case "USERROLE11116":
          return "GIDEPreneur"
        case "USERROLE11118":
          return "GIDE Counselor"
        default:
          return "UNKNOWN"
      }
    },
    /**
     * gpaths product Id List Get
     */
    async gpathsproductIdListGet () {
      try {
        const gpaList = await GPathConfig.gpcList(this, this.whereFilter)
        if (!gpaList.resp_status) {
          ApiResponse.responseMessageDisplay(this, gpaList)
          return
        }
        this.assessmentObjList = gpaList.resp_data.data
        this.gpcPdtIdList = this.assessmentObjList.map(gpc => ({
          id: gpc.gpc_pdt_id
        }))
      }
      catch (err) {
        console.error("Exception in gpathsproductIdListGet() and err: ", err.message)
      }
    },
    /**
     * getColorCode
     */
    getColorCode (pdtId) {
      if (pdtId == "APPGPATHPRODUCTID") {
        return `vertical-align: middle; color: #FFF; background: #994499 !important;`
      }
      else if (pdtId == "APPGPATHPRODUCTIDJEE") {
        return `vertical-align: middle; color: #FFF; background: #66AA00 !important;`
      }
      else if (pdtId == "APPGPATHPRODUCTIDNEET") {
        return `vertical-align: middle; color: #FFF; background: #0099C6 !important;`
      }
      else if (pdtId == "APPGPATHPRODUCTID08") {
        return `vertical-align: middle; color: #FFF; background: #88880d !important;`
      }
      else if (pdtId == "APPGPATHPRODUCTIDGRAD") {
        return `vertical-align: middle; color: #FFF; background: #B22222 !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: #5574A6 !important;`
      }
    },
    /**
     * remove All Filter
     */
    removeAllFilter () {
      this.whereFilter = {
        user_id: null,
        session_state: null,
        pdt_id: null,
        search_param: ""
      }

      this.gpath_sessionList()
    },
    /**
     * fixedClassName
     */
    fixedClassName (className) {
      if (className == 0) {
        return "-"
      }
      else if (className == 13) {
        return "Graduation"
      }
      else if (className == 14) {
        return "Post Graduation"
      }
      else if (className == 15) {
        return "PhD"
      }
      else {
        return className
      }
    }
  }
}
</script>
<style>
.card_title{
  display: flex;
  flex-wrap: wrap;
}
</style>
